(function () {
  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function setActiveSwatch(container, btn) {
    container.querySelectorAll(".confeet-swatch").forEach(b => b.classList.remove("is-active"));
    btn.classList.add("is-active");
  }

  function updateCardImage(card, imageUrl) {
    if (!imageUrl) return;

    // pega a imagem principal do card
    const img = card.querySelector(".card__media img, .card__inner img, img");
    if (!img) return;

    img.src = imageUrl;
    img.removeAttribute("srcset");
  }

  function updateCardLinks(card, variantId) {
    if (!variantId) return;

    const links = card.querySelectorAll('a[href*="/products/"]');
    links.forEach(a => {
      try {
        const url = new URL(a.href, window.location.origin);
        url.searchParams.set("variant", variantId);
        a.href = url.toString();
      } catch (e) {}
    });
  }

  function initCard(card) {
    const swatchWrap = card.querySelector(".confeet-card-swatches");
    if (!swatchWrap) return;

    const first = swatchWrap.querySelector(".confeet-swatch");
    if (first) first.classList.add("is-active");

    // Clique no swatch: não pode abrir o produto
    swatchWrap.addEventListener("click", function (e) {
      const btn = e.target.closest(".confeet-swatch");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.getAttribute("data-variant-id");
      const imageUrl = btn.getAttribute("data-variant-image");

      setActiveSwatch(swatchWrap, btn);
      updateCardImage(card, imageUrl);
      updateCardLinks(card, variantId);
    });

    // Bloqueia o "pointerdown" de subir pro overlay/link do Dawn
    swatchWrap.addEventListener(
      "pointerdown",
      function (e) {
        const btn = e.target.closest(".confeet-swatch");
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      },
      true
    );
  }

  // ========= NOVO: clique em qualquer lugar do card =========
  function shouldIgnoreCardClick(target) {
    // Não sequestra clique de elementos interativos
    if (target.closest(".confeet-card-swatches")) return true; // swatches
    if (target.closest("a")) return true;                      // links existentes
    if (target.closest("button")) return true;                 // botões
    if (target.closest("input, select, textarea, summary")) return true;
    if (target.closest("product-form, .quick-add, .quantity, .quantity-popover")) return true;
    if (target.closest("modal-opener, modal-dialog, quick-add-modal")) return true;
    return false;
  }

  function openFirstLink(container, selector) {
    const a = container.querySelector(selector);
    if (!a || !a.href) return false;
    window.location.href = a.href;
    return true;
  }

  function bindGlobalCardClicks() {
    // Captura no topo para funcionar mesmo quando o Dawn mexe em overlays
    document.addEventListener(
      "click",
      function (e) {
        const target = e.target;

        // 1) Produto: clique no card abre produto
        const productCardWrapper = target.closest(".card-wrapper.product-card-wrapper");
        if (productCardWrapper) {
          if (shouldIgnoreCardClick(target)) return;

          const opened = openFirstLink(productCardWrapper, 'a[href*="/products/"]');
          if (opened) {
            e.preventDefault();
            e.stopPropagation();
          }
          return;
        }

        // 2) Coleção: clique no card de coleção abre coleção
        // (usa seletores genéricos para cobrir "lista de coleções" + outros blocos)
        const collectionCardWrapper =
          target.closest(".collection-card-wrapper") ||
          target.closest(".card-wrapper.collection-card-wrapper") ||
          target.closest(".card-wrapper"); // fallback: tenta quando só existe wrapper genérico

        // Só tenta se tiver link de coleção dentro
        if (collectionCardWrapper && collectionCardWrapper.querySelector('a[href*="/collections/"]')) {
          if (shouldIgnoreCardClick(target)) return;

          const opened = openFirstLink(collectionCardWrapper, 'a[href*="/collections/"]');
          if (opened) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll(".card-wrapper.product-card-wrapper").forEach(wrapper => {
      const card = wrapper.querySelector(".card") || wrapper;
      if (card && card.querySelector(".confeet-card-swatches")) initCard(card);
    });

    bindGlobalCardClicks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
